module.exports = __webpack_public_path__ + "img/Character_Chongyun_Thumb.a241fb14.png";